import { Run, RunStatus } from '../../store/Run';
import { apiService } from '../APIService';

const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;

export const updateRunData = (runData: Partial<Run>) => {
  return apiService.callExternalApi<Run>({
    url: `${API_SERVER_URL}/runs/${runData.id}`,
    method: 'PUT',
    headers: {
      'content-type': 'application/json'
    },
    data: runData
  });
};

export const listRuns = (statuses: RunStatus[] | null = null) => {
  const params = statuses ? statuses.map((status) => `status=${status}`).join('&') : '';
  return apiService.callExternalApi<Run[]>({
    url: `${API_SERVER_URL}/runs?${params}`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const getActiveRunContext = () => {
  return apiService.callExternalApi<{ active: Run | null; next: Run | null; prev: Run | null }>({
    url: `${API_SERVER_URL}/runs/active-context`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const activateRun = (id: number) => {
  return apiService.callExternalApi<Run>({
    url: `${API_SERVER_URL}/runs/${id}/activate`,
    method: 'PUT',
    headers: {
      'content-type': 'application/json'
    }
  });
};
